import React from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardValue, KpiCard, Wrapper } from './KpiList.styles';
import { formatNumber, getFormattedSpendWithSymbol } from 'utils/number';

const KpiElement = ({ data, isLoading, isLeft }) => {
	return (
		<KpiCard isLeft={isLeft}>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<Wrapper>
					<div>
						<CardValue>{data.value1}</CardValue>
					</div>
					<div>
						<CardValue>{data.value2}</CardValue>
					</div>
				</Wrapper>
			)}
		</KpiCard>
	);
};

const KpiList = ({
	vendorCountData,
	vendorSpendData,
	isVendorSpendLoading,
	isVendorCountLoading,
}) => {
	const getTotal = data => {
		return data
			.map(vendor => vendor.value)
			.reduce((acc, curr) => acc + curr, 0);
	};

	return (
		<>
			<KpiElement
				data={{
					value1: 'Vendor Count',
					value2: formatNumber(getTotal(vendorCountData)),
				}}
				isLoading={isVendorCountLoading}
				isLeft={true}
			/>
			<KpiElement
				data={{
					value1: 'Total Spend',
					value2: getFormattedSpendWithSymbol(
						getTotal(vendorSpendData),
						'$',
						false
					).toUpperCase(),
				}}
				isLoading={isVendorSpendLoading}
				isLeft={false}
			/>
		</>
	);
};

export default KpiList;
